import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedCampaignDraftBudgetStep =
  () => import(/* webpackChunkName: "campaign-draft-budget-step.async" */ './campaign-draft-budget-step')
    .then(({ CampaignDraftBudgetStepWithI18n }) => CampaignDraftBudgetStepWithI18n);

const DelayedCampaignDraftBudgetLazyRepository =
  () => import(/* webpackChunkName: "campaign-draft-budget-step.async" */ './campaign-draft-budget-lazy-repository')
    .then(({ CampaignDraftBudgetLazyRepository }) => CampaignDraftBudgetLazyRepository);

export const CampaignDraftBudgetStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_DRAFT_BUDGET,
  view: DelayedCampaignDraftBudgetStep,
  repository: DelayedCampaignDraftBudgetLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
